const multiSelectFilterFn = (row: any, key: string, filterValue: string[]) =>
    filterValue.length === 0 || filterValue.includes(row.original[key]);

export { multiSelectFilterFn };
